import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import keys from 'ramda/src/keys';
import { connect } from 'react-redux';
import { dispatch } from '@ro-store';
import { translate } from 'react-i18next';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Divider from '@material-ui/core/Divider';

import Tutorial from '@ro-components/Tutorial';

import Layout from '@ro-components/Layout';

import ShortCutSwitch from '@ro-atoms/ShortCutSwitch';
import Icon from '@ro-atoms/Icon';
import HeaderWithIcon from '@ro-atoms/HeaderWithIcon';
import CustomPaper from '@ro-atoms/CustomPaper';
import { RoFormGroup } from '@ro-atoms/RoForm/';

const changeLayerState = (value, path) =>
  dispatch.ro.changeLayerState({
    path: ['userSettings', 'visibility', path],
    value: value
  });

class LayersSettings extends Component {
  render() {
    const { shortcuts, tile, visibility, t } = this.props;
    return (
      <Layout
        alpha={0.3}
        header={<HeaderWithIcon icon={<Icon name="eye fas" />} text={t(`settingsPage.layers.header`)} />}
      >
        <CustomPaper alpha={1}>
          <ShortCutSwitch
            createShortcut={dispatch.ro.createLayerShortcut}
            options={shortcuts.layersVisibilities}
            theme={tile}
            blackColor
            className={'vis_shortcut'}
          />
          <Divider light />
          {keys(visibility).map((item, i) => {
            return (
              <RoFormGroup key={item + '_' + i} className={'vis_layers'}>
                <FormControlLabel
                  control={
                    <Switch checked={visibility[item]} onChange={(event, checked) => changeLayerState(checked, item)} />
                  }
                  label={t(`settingsPage.layers.${item}`)}
                />
              </RoFormGroup>
            );
          })}
          <Tutorial name="visibility" />
        </CustomPaper>
      </Layout>
    );
  }
}

const mapStateToProps = ({ ro: { userSettings, currentLocation } }) => ({ ...userSettings, currentLocation });
export default withRouter(connect(mapStateToProps)(translate('common')(LayersSettings)));
